"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.derivePanReportPassword = derivePanReportPassword;
/**
 * Derives the password for a downloaded KYC PAN report from the exporting server user's own
 * identity, in the form `<username>@<serverUserId>@karya.in`.
 *
 * The password is never generated randomly and never transmitted — the backend derives it to
 * encrypt the file, and the frontend derives the same value from the already-loaded server user
 * record to display it, so both sides must stay in lockstep. `server_user` has no `username`
 * column, so the local part of `email` stands in for it; a user with no email falls back to their
 * server user id so the password is still deterministic and non-empty.
 */
function derivePanReportPassword(email, serverUserId) {
    const localPart = email != null && email.includes('@') ? email.split('@')[0] : undefined;
    const username = localPart != null && localPart.length > 0 ? localPart : serverUserId;
    return `${username}@${serverUserId}@karya.in`;
}
//# sourceMappingURL=PanReportPassword.js.map